module.exports = __webpack_public_path__ + "img/garbage_icon.a417f5d6.svg";